import { ajaxUploadImg, ajaxReadBarcode, ajaxCancelRequest } from "../api";
import { convertUrlToBlob, randomString } from "../utils/helpers";
import { DemoImageData } from "../store/features/imagesDataSlice";
import { Response } from "../store/features/responseSlice";

export default class Requester {
  private static consoleHeaderStyle = "font-family:unset;font-size:14px;background:#f4f4f4";

  public static readBarcodeXhr: Array<any> = [];
  public static uploadImgXhr: Array<any> = [];

  public static async uploadImgToServer(imageData: DemoImageData, uploadImgCallBack: () => void, uploadImgErrorCallBack: (statusText: string) => void): Promise<void> {
    const blob = await convertUrlToBlob(imageData.url as string);
    const fd = new FormData();
    fd.append("imgName", imageData.name);
    fd.append("imgBinary", blob);
    const uploadImgXhr = ajaxUploadImg(fd);
    uploadImgXhr.onload = () => {
      const response = JSON.parse(uploadImgXhr.response);
      if (uploadImgXhr.status === 200) {
        if (response.success) {
          uploadImgCallBack();
        } else {
          uploadImgErrorCallBack(response.message);
        }
      }
    }
    uploadImgXhr.onerror = (err: any) => {
      uploadImgErrorCallBack(err);
    }
    uploadImgXhr.onloadend = () => {
      Requester.uploadImgXhr = [];
    }
    Requester.uploadImgXhr.push(uploadImgXhr);
  }

  public static async uploadPdfToServer(imgName: string, imgBinary: Blob, uploadImgCallBack?: () => void, uploadImgErrorCallBack?: (statusText: string) => void): Promise<void> {
    const fd = new FormData();
    fd.append("imgName", imgName);
    fd.append("imgBinary", imgBinary);
    const uploadImgXhr = ajaxUploadImg(fd);
    uploadImgXhr.onload = () => {
      if (uploadImgXhr.status === 200) {
        const response = JSON.parse(uploadImgXhr.response);
        if (response.success) {
          uploadImgCallBack && uploadImgCallBack();
        } else {
          uploadImgErrorCallBack && uploadImgErrorCallBack(response.message);
        }
      }
    }
    uploadImgXhr.onerror = (err: any) => {
      uploadImgErrorCallBack && uploadImgErrorCallBack(err);
    }
    uploadImgXhr.onloadend = () => {
      Requester.uploadImgXhr = [];
    }
    Requester.uploadImgXhr.push(uploadImgXhr);
  }

  public static sendDecodeRequest(
    imageData: DemoImageData,
    settings: Array<any>,
    globalSettings: any,
    readBarcodeCallBack: (response: Response) => void,
    readBarcodeErrorCallBack: (response: Response) => void,
    readBarcodeCompleteCallBack: (response: Response) => void
  ) {
    const request = (decodeSettings: any) => {
      const fd: any = new FormData();
      const id = randomString(5);
      fd.append("reqId", id);
      fd.append("isSampleImg", imageData.sampleImg);
      fd.append("templateName", decodeSettings.CaptureVisionTemplates[0].Name);
      // If it is a .webp file, change the suffix to .png as in server it is saved as a .png file.
      fd.append("imgName", imageData.name.replace(/\.webp$/i, ".png"));
      fd.append("settings", JSON.stringify(decodeSettings));
      fd.append("pdfRasterDPI", globalSettings.PDFRasterDPI.value);
      fd.append("PDFReadingMode", globalSettings.PDFReadingMode.value[0]);
      if (undefined !== imageData.pageIndex) {
        fd.append("pageIndex", imageData.pageIndex);
      }
      Requester._sendDecodeAjaxRequest(settings.length > 1, fd, readBarcodeCallBack, readBarcodeErrorCallBack, readBarcodeCompleteCallBack);
    }
    for (let i = 0; i < settings.length; i++) {
      request(settings[i]);
    }
  }

  private static _sendDecodeAjaxRequest(
    isMulti: boolean,
    fd: FormData,
    readBarcodeCallBack: (response: Response) => void,
    readBarcodeErrorCallBack: (response: Response, isDecodeError?: boolean) => void,
    readBarcodeCompleteCallBack: (response: Response) => void,
  ) {
    const readBarcodeAjax: any = ajaxReadBarcode(fd);
    readBarcodeAjax.onload = () => {
      try {
        const resp = JSON.parse(readBarcodeAjax.response);
        if (readBarcodeAjax.status === 200) {
          if (resp.success) {
            console.log("%c Result barcodes: %o", Requester.consoleHeaderStyle, resp);
            readBarcodeCallBack(resp);
          } else {
            readBarcodeErrorCallBack(resp, true);
          }
        }
      } catch (ex: any) {
        readBarcodeErrorCallBack({ message: ex.message });
      }
    }
    readBarcodeAjax.onerror = () => {
      readBarcodeErrorCallBack({ message: "Internet error !" });
    }
    readBarcodeAjax.onabort = () => {
      readBarcodeErrorCallBack({ message: "abort" });
    }
    readBarcodeAjax.onloadend = () => {
      if (!isMulti) {
        Requester.readBarcodeXhr = [];
      } else {
        const index = Requester.readBarcodeXhr.indexOf(readBarcodeAjax);
        if (index !== -1) Requester.readBarcodeXhr.splice(index, 1);
      }
      const resp = readBarcodeAjax.response && JSON.parse(readBarcodeAjax.response);
      if (resp.isExpired) {
        Requester.cancelRequest();
      }
      readBarcodeCompleteCallBack(resp);
    }
    readBarcodeAjax.reqId = fd.get("reqId");
    Requester.readBarcodeXhr.push(readBarcodeAjax);
  }

  public static cancelRequest() {
    for (let i = 0; i < Requester.readBarcodeXhr.length; i++) {
      const fd = new FormData();
      fd.append("reqId", Requester.readBarcodeXhr[i].reqId);
      Requester.readBarcodeXhr[i].abort();
      const cancelXhr = ajaxCancelRequest(fd);
      cancelXhr.onload = () => {
        Requester.readBarcodeXhr.shift();
      }
    }
  }

  public static cancelUploadImgRequest() {
    for (let i = 0; i <  Requester.uploadImgXhr.length; i++) {
      Requester.uploadImgXhr[i].abort();
      Requester.uploadImgXhr.shift();
    }
  }
}